"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var config_1 = require("./config");
var translate_1 = require("./translate");
var form_map_1 = require("./form.map");
var ApiService_1 = require("./services/ApiService");
var $ = require("jquery");
var _ = require("lodash");
var i18next = require("i18next");
var Form = /** @class */ (function () {
    function Form(defaultVariables) {
        var _this = this;
        this.urlParams = {};
        this.offer = {};
        this.defaultParams = {};
        this.isReferralToggle = true;
        this.validAddress = true;
        this.individualProfile;
        this.elevation = 0;
        this.polygons = [];
        this.surfaceCoordinates = [[]];
        this.searchWithoutAddress = false;
        this.waitingResponse = false;
        this.areaM2 = [];
        this.curStep = 1;
        this.referral = false;
        this.nAreas = 0;
        this.submitted = false;
        this.referral = false;
        this.validTariffs = [
            "2.0TD",
            "3.0TD",
            "3.0TDVE",
            "6.1TD",
            "6.2TD",
            "6.3TD",
            "6.4TD",
            "6.1TDVE",
        ];
        this.tariffOptions = {};
        this.getTariffs(config_1.config.context.defaultCountryCode);
        this.consumptionType;
        this.calculatedConsumption;
        this.tariffName;
        this.contractedPower;
        this.legalRepresentation = "INDIVIDUAL";
        this.checkIFrame();
        this.checkLimitations();
        this.joinDefaultVariables(defaultVariables);
        this.getUrlVariables();
        this.initOffer().then(function () {
            _this.mapa = new form_map_1.Mapa(_this.moduleId);
            _this.initAutocomplete();
        });
        this.goToStep(1);
        // this.validateStep1Form();
        this.validateStep3Form();
        translate_1.setValidationMessages();
        this.setEvents();
        this.getCups();
        // });
    }
    /**
     * Checks some config show conditions in order to display or not the content
     */
    Form.prototype.checkLimitations = function () {
        if (!config_1.config.showLanguageSelector)
            $(".language-selector").css("display", "none");
    };
    /**
     * Check if the form is is inside an iframe or not
     */
    Form.prototype.checkIFrame = function () {
        this.isIFrame = window.self !== window.top;
        if (this.isIFrame) {
            $("#header").css("display", "none");
        }
    };
    /**
     * Calculate the total consumption
     * @param consumptionType 'power' or 'cost'
     * @param consumption total consumption in kWh (power) or € (cost)
     * @param tariffName tariff name selected
     * @param contractedPower contracted power in kW
     */
    Form.prototype.calculateConsumption = function (consumptionType, consumption, tariffName, contractedPower) {
        var totalConsumptionCalculated;
        var tariff = _.find(this.tariffOptions, function (tariff) {
            return tariff.name === tariffName;
        });
        var fixCost = _.sum(this.getFixCostPerPower(tariff, contractedPower));
        if (consumptionType === "power") {
            var variableCost = consumption * tariff.variableCostAverage;
            this.calculatedConsumption = _.ceil(variableCost + fixCost);
            totalConsumptionCalculated = consumption;
        }
        else {
            var variableCost = consumption - Math.min(fixCost, consumption * 0, 2);
            this.calculatedConsumption = _.ceil(variableCost / (tariff.variableCostAverage / 1000) / 1000);
            totalConsumptionCalculated = this.calculatedConsumption;
        }
        return totalConsumptionCalculated;
    };
    Form.prototype.initOffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.offer.domainId = config_1.config.context.domainId;
                        this.offer.powerPlantData = {
                            supplyPoint: {
                                tariffName: config_1.config.context.defaultTariff,
                                contractedPower: config_1.config.context.defaultContractedPower,
                                voltage: config_1.config.context.defaultVoltage,
                                phases: config_1.config.context.defaultPhases,
                            },
                        };
                        this.offer.legalRepresentation = this.legalRepresentation;
                        return [4 /*yield*/, this.setChannel(config_1.config.context.channelCode)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setWizard(config_1.config.context.wizardCode)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setIndividualProfile(config_1.config.context.defaultProfileRef)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.setSolution(config_1.config.context.solutionCode)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.setIndividualProfile = function (ref) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService_1.ApiService.getConsumptionProfile(config_1.config.context.domainId, ref)];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            this.individualProfile = data.id;
                        }
                        else {
                            console.error("Error on get Profile");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.setChannel = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.offer;
                        return [4 /*yield*/, ApiService_1.ApiService.getChannel(config_1.config.context.domainId, code)];
                    case 1:
                        _a.channelId = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error("Error on get Channel", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.setWizard = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService_1.ApiService.getWizard(config_1.config.context.domainId, code)];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            this.offer.wizardId = data.id;
                        }
                        else {
                            console.error("Error on get Wizard");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.setSolution = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var solution, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiService_1.ApiService.getSolution(code)];
                    case 1:
                        solution = _a.sent();
                        this.offer.solutionId = solution.id;
                        if (_.get(solution, "solutionEngineConfig.modules.defaultProduct")) {
                            this.moduleId = _.get(solution, "solutionEngineConfig.modules.defaultProduct");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Error on get Solution", error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.initAutocomplete = function () {
        var _this = this;
        // Create the search box and link it to the UI element.
        var input = document.getElementById("pac-input");
        var options = {
            componentRestrictions: { country: config_1.config.context.regionAutocomplete },
        };
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        autocomplete.bindTo("bounds", this.mapa.map);
        autocomplete.addListener("place_changed", function () {
            var places = autocomplete.getPlace();
            if (!places.geometry) {
                return;
            }
            // For each place, get the icon, name and location.
            var bounds = new google.maps.LatLngBounds();
            // If the place has a geometry, then present it on a map.
            if (places.geometry.viewport) {
                ////this.mapa.map.fitBounds(places.geometry.viewport);
            }
            else {
                _this.mapa.map.setCenter(places.geometry.location);
                _this.mapa.map.setZoom(17);
            }
            _this.offer.powerPlantData.supplyPoint.totalConsumption =
                _this.calculateConsumption("cost", $("#consumeInput").val() * 12, _this.offer.powerPlantData.supplyPoint.tariffName, _this.offer.powerPlantData.supplyPoint.contractedPower);
            _this.mapa.offer = _this.offer;
            if (places.address_components) {
                _this.mapa.calculateRecommend(config_1.config.context.defaultModulesAzimuth, config_1.config.context.defaultModulesTilt, places.geometry.location.lat(), places.geometry.location.lng(), null, _this.offer.powerPlantData.supplyPoint.totalConsumption);
                _this.setAddress(places);
                if (_this.validAddress) {
                    $("#step1 .no-valid-address").css("display", "none");
                    _this.goToStep(2);
                    _this.mapa.searchInMap(places);
                }
                else {
                    $("#step1 .no-valid-address").css("display", "block");
                }
            }
        });
    };
    Form.prototype.getUrlVariables = function () {
        var _this = this;
        var href = window.location.href.split("#");
        href[0].replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
            _this.urlParams[name] = value;
            return "";
        });
        this.search = window.location.search;
        if (this.urlParams["key"]) {
            config_1.config.apiKey = this.urlParams["key"];
        }
        if (!this.urlParams["urlOk"] && config_1.config.redirect) {
            this.urlParams.urlOk = this.defaultParams.urlOk;
        }
        $("#backButton").attr("href", this.urlParams.urlBack || this.defaultParams.urlBack);
    };
    Form.prototype.joinDefaultVariables = function (defaultVariables) {
        this.mergeObjects(this.defaultParams, defaultVariables);
    };
    Form.prototype.mergeObjects = function (object1, object2) {
        for (var attrname in object2) {
            object1[attrname] = object2[attrname];
        }
        return object1;
    };
    Form.prototype.goToStep = function (step) {
        this.curStep = step;
        var steps = document.getElementsByClassName("step");
        for (var i = 0; i < steps.length; i++) {
            steps[i].style.display = "none";
        }
        history.pushState(null, null, "#step" + step);
        var step1 = document.getElementById("step" + step);
        step1.style.display = "block";
        if (step == 1) {
            $("#header").css("display", "block");
        }
        if (step == 2) {
            this.mapa.resizeMap();
            $("#header").css("display", "none");
        }
        if (step == 3) {
            this.isIFrame
                ? $("#header").css("display", "none")
                : $("#header").css("display", "block");
        }
    };
    // public validateStep1Form() {
    //   var that = this;
    //   (<any>$("#step1Form")).validate({
    //     rules: {
    //       ContactName: {
    //         required: true,
    //       },
    //       ContactLastName: {
    //         required: true,
    //       },
    //       Email: {
    //         required: true,
    //         pattern: /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i,
    //       },
    //       PhoneNumber: {
    //         required: true,
    //         minlength: 9,
    //         phoneNumberEs: true,
    //       },
    //       Address: {
    //         required: true,
    //       },
    //       Number: {
    //         required: true,
    //         number: true,
    //       },
    //       PostalCode: {
    //         required: true,
    //         pattern: /^(5[0-2]|[0-4][0-9])[0-9]{3}$/,
    //       },
    //       Province: {
    //         required: true,
    //       },
    //       City: {
    //         required: true,
    //       },
    //       Tariff: {
    //         required: true,
    //       },
    //       Terms: {
    //         required: true,
    //       },
    //       TotalConsumption: {
    //         required: true,
    //         pattern: /^[0-9]*$/,
    //       },
    //       ContractedPower: {
    //         required: true,
    //         pattern: /^(([1-9][0-9]*)|(([1-9][0-9]*)\,([0-9]*)))$/,
    //       },
    //       referralEmployee: {
    //         required: true,
    //       },
    //       referralEmail: {
    //         required: true,
    //         pattern: /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(endesa|enel)\.(com|es)$/,
    //         email: true,
    //       },
    //     },
    //     errorPlacement: function (error, element) {
    //       if (element.parent(".input-group").length) {
    //         error.insertAfter(element.parent());
    //       } else {
    //         error.insertAfter(element);
    //       }
    //     },
    //     submitHandler: (form) => {
    //       var $form = $(form);
    //       this.setProvince("step1Form");
    //       this.calculateConsumption2(
    //         $("select[name=totalConsumptionUnits]").val(),
    //         $("#totalConsumption").val(),
    //         $form.find("select[name=Tariff]").val(),
    //         (<any>$form.find("input[name=ContractedPower]"))
    //           .val()
    //           .replace(",", "."),
    //         (totalConsumptionCalculated) => {
    //           this.offer = {
    //             domainId: config.context.domainId,
    //             channelId:
    //               this.urlParams.channelId || this.defaultParams.channelId,
    //             address: $form.find("input[name=Address]").val(),
    //             province: $form.find("input[name=Province]").val(),
    //             postalCode: $form.find("input[name=PostalCode]").val(),
    //             addressNumber: $form.find("input[name=Number]").val(),
    //             town: $form.find("input[name=City]").val(),
    //             tariff: $form.find("select[name=Tariff]").val(),
    //             slopedRoof: 0,
    //             powerPlantData: {
    //               supplyPoint: {
    //                 totalConsumption: parseInt(totalConsumptionCalculated),
    //               },
    //             },
    //             referralEmployee:
    //               $form.find("input[name=referralEmployee]").val() || null,
    //             referralEmail:
    //               $form.find("input[name=referralEmail]").val() || null,
    //             contractedPower: (<any>$form.find("input[name=ContractedPower]"))
    //               .val()
    //               .replace(",", "."),
    //             wizardId: this.defaultParams.wizardId,
    //             contactName: that.referral
    //               ? null
    //               : $form.find("input[name=ContactName]").val(),
    //             contactLastName: that.referral
    //               ? null
    //               : $form.find("input[name=ContactLastName]").val(),
    //             email: that.referral
    //               ? null
    //               : $form.find("input[name=Email]").val(),
    //             phoneNumber: that.referral
    //               ? null
    //               : $form
    //                   .find("input[name=PhoneNumber]")
    //                   .val()
    //                   .replace(/\s+/g, "")
    //           };
    //           this.tariffName = $form.find("select[name=Tariff]").val();
    //           this.contractedPower = (<any>(
    //             $form.find("input[name=ContractedPower]")
    //           ))
    //             .val()
    //             .replace(",", ".");
    //           this.mapa.offer = this.offer;
    //           // this.setAddress(true);
    //           this.switchModeUserReferralUrl();
    //           this.goToStep(2);
    //           // this.mapa.searchInMap();
    //         }
    //       );
    //     },
    //   });
    // }
    Form.prototype.findCodeAddress = function (array, code) {
        var data = _.find(array, function (item) {
            return (_.findIndex(item.types, function (type) {
                return type === code;
            }) !== -1);
        });
        return data ? data.long_name : null;
    };
    Form.prototype.setAddress = function (places) {
        var street = this.findCodeAddress(places.address_components, "route") ||
            this.findCodeAddress(places.address_components, "town_square");
        var addressNumber = this.findCodeAddress(places.address_components, "street_number");
        var province = this.findCodeAddress(places.address_components, "administrative_area_level_2");
        var town = this.findCodeAddress(places.address_components, "locality");
        var postalCode = this.findCodeAddress(places.address_components, "postal_code");
        var country = this.findCodeAddress(places.address_components, "country");
        if (street && postalCode) {
            this.validAddress = true;
            this.offer.address = street;
            this.offer.addressNumber = addressNumber;
            if (postalCode)
                this.setProvince(province, postalCode);
            else
                this.offer.province = province;
            this.offer.town = town;
            this.offer.postalCode = postalCode;
            var address = "";
            if (street)
                address += street + " ";
            if (addressNumber)
                address += addressNumber + ", ";
            if (town)
                address += town + ", ";
            if (postalCode)
                address += postalCode + ", ";
            if (country)
                address += country;
            $("#step2 .map-address .map-address-description input").val(address);
            $("#step3 .address span").text(address);
        }
        else {
            this.validAddress = false;
        }
    };
    Form.prototype.setProvince = function (province, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            var postalCodeParsed, _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        postalCodeParsed = postalCode.substring(0, 2);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this.offer;
                        return [4 /*yield*/, ApiService_1.ApiService.getProvince(postalCodeParsed)];
                    case 2:
                        _a.province = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.offer.province = province;
                        console.error("Error on get Province", error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.validateStep3Form = function () {
        var that = this;
        $("#step3Form").validate({
            rules: {
                Name: {
                    required: true,
                },
                // LastName: {
                //   required: true,
                // },
                Email: {
                    required: true,
                    pattern: /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i,
                },
                Profiles: {
                    required: true,
                },
                // referralEmployee: {
                //   required: true,
                // },
                // referralEmail: {
                //   required: true,
                //   pattern: /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(endesa|enel)\.(com|es)$/,
                //   email: true,
                // },
                documentType: {
                    required: true,
                },
                documentNumber: {
                    required: false,
                    nifES: {
                        depends: function () {
                            return $("#documentType").val() === "nif";
                        },
                    },
                    dniES: {
                        depends: function () {
                            return $("#documentType").val() === "dni";
                        },
                    },
                    nieES: {
                        depends: function () {
                            return $("#documentType").val() === "nie";
                        },
                    },
                },
                PhoneNumber: {
                    required: false,
                    minlength: 9,
                    phoneNumberEs: true,
                },
                // CUPS: {
                //   required: false,
                //   pattern: /^[A-Za-z]{2}[0-9]{16}[A-Za-z]{2}(?:[0-1]{1}[A-Za-z]{1})?$/,
                // },
                Terms: {
                    required: true,
                },
                ContactName: {
                    required: true,
                },
                ContactLastName: {
                    required: true,
                },
                ContactDocumentType: {
                    required: true,
                },
                ContactDocumentNumber: {
                    required: true,
                    nifES: {
                        depends: function () {
                            return $("#contactDocumentType").val() === "nif";
                        },
                    },
                    dniES: {
                        depends: function () {
                            return $("#documentType").val() === "dni";
                        },
                    },
                    nieES: {
                        depends: function () {
                            return $("#contactDocumentType").val() === "nie";
                        },
                    },
                },
            },
            errorPlacement: function (error, element) {
                error.insertAfter(element);
            },
            submitHandler: function (form) {
                var $form = $(form);
                that.offer.name =
                    that.legalRepresentation == "INDIVIDUAL"
                        ? $form.find("input[name=ContactName]").val()
                        : $form.find("input[name=Name]").val();
                that.offer.lastName =
                    that.legalRepresentation == "INDIVIDUAL"
                        ? $form.find("input[name=ContactLastName]").val()
                        : $form.find("input[name=LastName]").val();
                that.offer.email =
                    $form.find("input[name=Email]").val() || that.offer.email;
                that.offer.phoneNumber =
                    $form.find("input[name=PhoneNumber]").val().replace(/\s+/g, "") ||
                        that.offer.phoneNumber;
                that.offer.documentNumber = $form
                    .find("input[name=documentNumber]")
                    .val();
                that.offer.documentType =
                    $form.find("select[name=documentType]").val() || "nif";
                that.offer.powerPlantData.profileId =
                    that.legalRepresentation == "INDIVIDUAL"
                        ? that.individualProfile
                        : $form.find("select[name=Profiles]").val();
                (that.offer.powerPlantData.annualPowerPriceIncrease =
                    config_1.config.context.defaultAnnualPowerPriceIncrease),
                    (that.offer.powerPlantData.annualPerformanceLoss =
                        config_1.config.context.defaultAnnualPerformanceLoss),
                    (that.offer.powerPlantData.annualPowerConsumptionIncrease =
                        config_1.config.context.defaultAnnualPowerConsumptionIncrease),
                    (that.offer.notes = $form.find("textarea[name=Notes]").val());
                that.offer.ecommerceData = {
                    financing: {
                        financingType: config_1.config.context.financingType,
                    },
                };
                that.offer.legalRepresentation = that.legalRepresentation;
                that.offer.contactName =
                    $form.find("input[name=ContactName]").val() || that.offer.contactName;
                that.offer.contactLastName =
                    $form.find("input[name=ContactLastName]").val() ||
                        that.offer.contactLastName;
                that.offer.estimatedSavingsId = that.mapa.estimatedSavingsId;
                // (that.offer.referralEmail = null),
                //   (that.offer.referralEmployee = null),
                //that.offer.referralOrganization = $form.find('input[name=referralOrganization]').val();
                // that.offer.referralEmployee =
                //   $form.find("input[name=referralEmployee]").val() ||
                //   that.offer.referralEmployee;
                // that.offer.referralEmail =
                //   $form.find("input[name=referralEmail]").val() ||
                //   that.offer.referralEmail;
                that.offer.powerPlantData.supplyPoint.tariffName =
                    $form.find("select[name=Tariff]").val() ||
                        that.offer.powerPlantData.supplyPoint.tariffName;
                that.offer.powerPlantData.supplyPoint.contractedPower =
                    $form.find("input[name=ContractedPower]").val().replace(",", ".") ||
                        that.offer.powerPlantData.supplyPoint.contractedPower;
                delete that.offer.slopedRoof;
                that.offer.countryCode = config_1.config.context.defaultCountryCode;
                that.offer.processType = "sales";
                that.submitForm(that.offer);
            },
        });
    };
    /**
     * Get cups
     * @param estimatedTypeCupsCode cups code
     */
    Form.prototype.getCups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, hits, elm, df, _i, hits_1, res, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService_1.ApiService.searchConsumptionProfiles(config_1.config.context.domainId, "ORGANIZATION")];
                    case 1:
                        data = _a.sent();
                        if (data && data.hits && data.hits.hits) {
                            hits = data.hits.hits;
                            elm = document.getElementById("profiles"), df = document.createDocumentFragment();
                            for (_i = 0, hits_1 = hits; _i < hits_1.length; _i++) {
                                res = hits_1[_i];
                                option = document.createElement("option");
                                option.value = res._id;
                                option.appendChild(document.createTextNode(res._source.name));
                                df.appendChild(option);
                            }
                            elm.appendChild(df);
                        }
                        else {
                            console.error("Error on get ConsumptionProfiles");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all tariffs
     */
    Form.prototype.getTariffs = function (forecastPlanCode) {
        return __awaiter(this, void 0, void 0, function () {
            var data, forecastPlanId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService_1.ApiService.getForecastPlans(forecastPlanCode)];
                    case 1:
                        data = _a.sent();
                        if (!data) return [3 /*break*/, 3];
                        forecastPlanId = data[0].id;
                        return [4 /*yield*/, this.getTariffOptions(forecastPlanId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        console.error("Error on get ForecastPlans");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.getTariffOptions = function (forecastPlanId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, elm, df, _i, _a, tariffOption, option;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiService_1.ApiService.getForecastPlanTariffs(forecastPlanId, this.validTariffs)];
                    case 1:
                        data = _b.sent();
                        if (data && data.length > 0) {
                            this.tariffOptions = data;
                            elm = document.getElementById("tariff"), df = document.createDocumentFragment();
                            for (_i = 0, _a = this.tariffOptions; _i < _a.length; _i++) {
                                tariffOption = _a[_i];
                                option = document.createElement("option");
                                option.value = tariffOption.name;
                                option.appendChild(document.createTextNode(tariffOption.name));
                                df.appendChild(option);
                            }
                            elm.appendChild(df);
                        }
                        else {
                            console.error("Error on get ForescastPlanTariffs");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Calculate and returns the fixCost by its contracted power
     * @param tariff
     * @param contractedPower
     */
    Form.prototype.getFixCostPerPower = function (tariff, contractedPower) {
        var fixCostPerPower = _.fill(Array(6), 0);
        for (var i = 0; i < tariff.fixCost.length; i++) {
            fixCostPerPower[i] = tariff.fixCost[i] * contractedPower;
        }
        return fixCostPerPower;
    };
    /**
     * Calculate the total consumption
     * @param consumptionType 'power' or 'cost'
     * @param consumption total consumption in kWh (power) or € (cost)
     * @param tariffName tariff name selected
     * @param contractedPower contracted power in kW
     */
    // public calculateConsumption2(
    //   consumptionType: string,
    //   consumption: number,
    //   tariffName: string,
    //   contractedPower: number,
    //   callback: Function
    // ) {
    //   var that = this;
    //   var totalConsumptionCalculated;
    //   const tariff = _.find(that.tariffOptions, (tariff) => {
    //     return tariff.name === tariffName;
    //   });
    //   const fixCost = _.sum(this.getFixCostPerPower(tariff, contractedPower));
    //   if (consumptionType === "power") {
    //     const variableCost = consumption * tariff.variableCostAverage;
    //     that.calculatedConsumption = _.ceil(variableCost + fixCost);
    //     totalConsumptionCalculated = consumption;
    //   } else {
    //     const variableCost = consumption - fixCost;
    //     that.calculatedConsumption = _.ceil(
    //       variableCost / (tariff.variableCostAverage / 1000) / 1000
    //     );
    //     totalConsumptionCalculated = that.calculatedConsumption;
    //   }
    //   callback(totalConsumptionCalculated);
    // }
    Form.prototype.submitForm = function (params) {
        this.setOffer(params, "POST");
    };
    Form.prototype.setOffer = function (params, method) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $("button[type=submit], input[type=submit]").prop("disabled", true);
                        if (this.submitted)
                            return [2 /*return*/];
                        this.submitted = true;
                        $("#step3Form").hide();
                        $(".send-message .sending").show();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ApiService_1.ApiService.submitWizard(params, method, this.offer.id, this.offer.token)];
                    case 2:
                        response = _a.sent();
                        this.offer = response;
                        $(".send-message .sending").hide();
                        if (config_1.config.redirect) {
                            if (this.isIFrame)
                                window.top.location.replace(this.urlParams.urlOk);
                            else
                                window.location.replace(this.urlParams.urlOk);
                        }
                        else {
                            $(".send-message .success-text").show();
                        }
                        $("#clientName").text(params.name);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        $(".send-message .sending").hide();
                        $("#step3Form").show();
                        $("#formError").modal("show");
                        $("#clientName").text(params.name);
                        this.submitted = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.validateDNI = function (documentNumber) {
        if (!documentNumber.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)"))
            return false;
        if (/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(documentNumber)) {
            if ("TRWAGMYFPDXBNJZSQVHLCKE".charAt(documentNumber.substring(8, 0) % 23) === documentNumber.charAt(8))
                return true;
            else
                return false;
        }
    };
    Form.prototype.setEvents = function () {
        var _this = this;
        var that = this;
        $("#consumeInput").on("change", function () {
            _this.offer.powerPlantData.supplyPoint.totalConsumption =
                _this.calculateConsumption("cost", $("#consumeInput").val() * 12, _this.offer.powerPlantData.supplyPoint.tariffName, _this.offer.powerPlantData.supplyPoint.contractedPower);
            _this.mapa.calculateRecommend(_this.mapa.moduleArea[0].azimuth, _this.mapa.moduleArea[0].tilt, _this.mapa.coordinates.lat(), _this.mapa.coordinates.lng(), parseInt(_this.mapa.moduleArea[0].modulePower), parseInt(_this.offer.powerPlantData.supplyPoint.totalConsumption));
        });
        $("#togBtn").on("change", function () {
            if ($(this).is(":checked")) {
                $(this).attr("value", "true");
                $(".option1").removeClass("checked");
                $(".option2").addClass("checked");
                $(".option1").css("color", "#6b6b6b");
                $(".option2").css("color", "white");
                $("#step3 .middle-colum").css("min-height", "1052px");
                that.legalRepresentation = "ORGANIZATION";
                $(".organization").css("display", "block");
                $(".individual").css("display", "none");
                $("#consumeInput").attr({ max: config_1.config.context.organizationMaxConsume });
                $("#consumeInput").attr({
                    value: config_1.config.context.organizationDefaultConsume,
                });
                $("#consumeOutput").text(config_1.config.context.organizationDefaultConsume);
                $(".no-tax").css("display", "block");
                $(".tax").css("display", "none");
                $("#step3 .tariff").css("display", "block");
                $("#step3 .power").css("display", "block");
                $("#step3 .bussines-name").css("display", "block");
                $("#step3 .profiles-name").css("display", "block");
                that.offer.powerPlantData.supplyPoint.tariffName =
                    config_1.config.context.organizationTariff;
                that.offer.powerPlantData.supplyPoint.contractedPower =
                    config_1.config.context.organizationContractedPower;
            }
            else {
                $(this).attr("value", "false");
                $(".option2").removeClass("checked");
                $(".option1").addClass("checked");
                $(".option1").css("color", "white");
                $(".option2").css("color", "#6b6b6b");
                $("#step3 .middle-colum").css("min-height", "670px");
                that.legalRepresentation = "INDIVIDUAL";
                $(".organization").css("display", "none");
                $(".individual").css("display", "block");
                $("#consumeInput").attr({ max: config_1.config.context.individualMaxConsume });
                $("#consumeInput").attr({
                    value: config_1.config.context.individualDefaultConsume,
                });
                $("#consumeOutput").text(config_1.config.context.individualDefaultConsume);
                $(".tax").css("display", "block");
                $(".no-tax").css("display", "none");
                $("#step3 .tariff").css("display", "none");
                $("#step3 .power").css("display", "none");
                $("#step3 .bussines-name").css("display", "none");
                $("#step3 .profiles-name").css("display", "none");
                that.offer.powerPlantData.supplyPoint.tariffName =
                    config_1.config.context.individualTariff;
                that.offer.powerPlantData.supplyPoint.contractedPower =
                    config_1.config.context.individualContractedPower;
            }
            that.offer.legalRepresentation = that.legalRepresentation;
        });
        $("#documentType").val("nif");
        window.addEventListener("popstate", function (e) {
            if (that.curStep == 2) {
                $("body").removeClass();
                that.goToStep(1);
                that.mapa.clearListeners();
                that.mapa.resetMap();
            }
            if (that.curStep == 3) {
                that.goToStep(2);
            }
        });
        if (this.urlParams.referral && this.urlParams.referral === "true") {
            this.isReferralToggle = true;
            $("#ref-contact-step1").hide();
            $("#logo-header").attr("href", "");
            $("#row-referralEmployee, #row-referralEmail").show();
        }
        else {
            this.isReferralToggle = false;
        }
        // $("#step1 #email").on("change", function () {
        //   that.checkIfEmailReferral(this.value);
        // });
        $("#step3 #email").on("change", function () {
            if (this.value.includes("@endesa.com") ||
                this.value.includes("@enel.com") ||
                this.value.includes("@endesa.es") ||
                this.value.includes("@enel.es")) {
                $(".toggle-message").css("display", "block");
                $("#step3 #email").val(" ");
            }
            else {
                $(".toggle-message").css("display", "none");
            }
        });
        $("#submitStep1").on("click", function () {
            $("#step1Form").submit();
        });
        $("#submitStep2").on("click", function () {
            that.submitStep2();
        });
        $("#gotostep3").on("click", function () {
            that.submitStep2();
        });
        $(document).on("click", "#submitStep3", function () {
            $("#step3Form").submit();
        });
        $('[data-toggle="tooltip"]').tooltip();
        $("#documentNumber").on("focus", function () {
            $(".side-alert").addClass("animate-opacity");
        });
        $("#direccion").on("focus", function () {
            $(".street-message").show();
        });
        $("#direccion").on("blur", function () {
            $(".street-message").hide();
        });
        $("#documentNumber").on("blur", function () {
            $(".side-alert").removeClass("animate-opacity");
        });
        $("#step1 .no-valid-address").css("display", "none");
        $("#step2 .map-address-modify button").on("click", function () {
            $("body").removeClass();
            $("#step1 #logo-header").css("display", "block");
            $("#pac-input").val("");
            $("#step1 .no-valid-address").css("display", "none");
            that.goToStep(1);
            that.mapa.clearListeners();
            that.mapa.resetMap();
        });
        $("#step3 .map-address-modify button").on("click", function () {
            that.goToStep(2);
        });
        $(".send-message button").on("click", function () {
            if (config_1.config.redirect) {
                location.href = _this.defaultParams.urlOk + _this.search;
            }
        });
        $(window).on("resize", function () {
            if (that.curStep == 2) {
                that.mapa.resizeMap();
            }
        });
        $.validator.addMethod("phoneNumberEs", function (value, element) {
            "use strict";
            value = value.replace(/\s+/g, "");
            return this.optional(element) || value.match(/^\+?([0-9]|\s){9,}$/);
        });
        $.validator.addMethod("nieES", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            // Basic format test
            if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
                return false;
            }
            // Test NIE
            //T
            if (/^[T]{1}/.test(value)) {
                return value[8] === /^[T]{1}[A-Z0-9]{8}$/.test(value);
            }
            //XYZ
            if (/^[XYZ]{1}/.test(value)) {
                return (value[8] ===
                    "TRWAGMYFPDXBNJZSQVHLCKE".charAt(value
                        .replace("X", "0")
                        .replace("Y", "1")
                        .replace("Z", "2")
                        .substring(0, 8) % 23));
            }
            return false;
        });
        $.validator.addMethod("passportES", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            return false;
        });
        $.validator.addMethod("documentNumber", function (value, element) {
            "use strict";
            value = value.toUpperCase();
            if (value == "" ||
                /^[ABCDEFGHJNPQRSUVW][0-9]{8}$/.test(value) ||
                /^[ABCDEFGHJNPQRSUVW][0-9]{7}[A-J]$/.test(value) ||
                /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/.test(value) ||
                that.validateDNI(value)) {
                return true;
            }
            else
                return false;
        }, function () {
            if (that.getLanguage() === "es") {
                return "El formato del documento no es correcto";
            }
            if (that.getLanguage() === "cat") {
                return "El format del document no és correcte";
            }
        });
        $.validator.addMethod("dniES", function (value, element) {
            "use strict";
            // Basic format test
            return that.validateDNI(value.toUpperCase());
        });
    };
    /**
     * Check if email contains @endesa.com or @enel.com to change referral = true mode. Controls
     * the question referral div and the message referral email
     */
    // private checkIfEmailReferral(value: any): void {
    //   if (
    //     value.includes("@endesa.com") ||
    //     value.includes("@enel.com") ||
    //     value.includes("@endesa.es") ||
    //     value.includes("@enel.es")
    //   ) {
    //     $(".switch-input").prop("checked", true);
    //     $("#row-referralEmployeeStep1, #row-referralEmailStep1").show();
    //     $(".toggle-message").css("display", "block");
    //     $("#email").val(" ");
    //     $(".toggle-referral").css("display", "flex");
    //   } else {
    //     $(".toggle-message").css("display", "none");
    //   }
    // }
    /**
     * Check if its referral mode or not and show/hide attributes.
     */
    // private switchModeUserReferralUrl(): void {
    //   if (this.isReferralToggle) {
    //     $("#row-referralEmployee, #row-referralEmail").show();
    //     if ($("#row-referralEmployeeStep1").is(":visible")) {
    //       $(
    //         "#row-referralEmployee, #row-referralEmail, #ref-contact-step3"
    //       ).hide();
    //       $("#step3 .middle-colum").css("min-height", "830px");
    //     }
    //   } else {
    //     $("#ref-contact-step3").hide();
    //     $("#ref-terms-step3").hide();
    //     $("#step3 .middle-colum").css("min-height", "794px");
    //   }
    // }
    Form.prototype.getLanguage = function () {
        var lang = i18next.default.options.fallbackLng[0];
        if (i18next.default.language != undefined) {
            lang = i18next.default.language;
        }
        return lang;
    };
    Form.prototype.submitStep2 = function () {
        $("#step3 .m2_in_map span").html(this.numberWithPoints(this.mapa.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0)) + "m<sup>2</sup>");
        if (this.mapa.offer) {
            this.offer = this.mapa.offer;
            this.offer.powerPlantData.map = {
                surfaceCoordinates: this.mapa.surfaceCoordinates,
                coordinates: this.mapa.coordinates,
                elevation: this.mapa.elevation,
                layout: {
                    map: {
                        zoom: 18,
                        geopoint: this.mapa.coordinates,
                        surfaceCoordinates: this.mapa.surfaceCoordinates,
                        elevation: this.mapa.elevation,
                    },
                    modules: this.mapa.modulesPolygonsLayout,
                    moduleArea: this.mapa.moduleArea,
                    totalModules: this.mapa.totalModules,
                    totalPower: this.mapa.totalPower,
                    totalSurface: this.mapa.totalSurface,
                    batteriesPower: 0,
                    batteryLines: [],
                    defaultModuleId: this.mapa.moduleId,
                    defaultStructureId: parseInt($("#menu li.current").attr("value")) == 0
                        ? this.mapa.flatStructure
                        : this.mapa.inclinationStructure,
                },
            };
            for (var _i = 0, _a = this.offer.powerPlantData.map.layout.moduleArea; _i < _a.length; _i++) {
                var area = _a[_i];
                area.structureId =
                    parseInt($("#menu li.current").attr("value")) == 0
                        ? this.mapa.flatStructure
                        : this.mapa.inclinationStructure;
            }
        }
        $(".left-colum").css("left", "400px");
        $(".right-colum").css("left", "-400px");
        this.goToStep(3);
        $(".left-colum").animate({ left: "0px" }, "slow");
        $(".right-colum").animate({ left: "0px" }, "slow");
        this.mapa.getStaticMap(this.mapa.surfaceCoordinates);
    };
    Form.prototype.numberWithPoints = function (x) {
        if (x != undefined) {
            x = Math.floor(x);
            x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        else {
            x = 0;
        }
        return x;
    };
    return Form;
}());
exports.Form = Form;
